import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    timestamp: '',
    shopId: '',
    openid: '',  // LINE LIFF userId，由 main.js 初始化後寫入
    baseUrl: 'https://nike.cheflemon.co/api',
    language: 'TC',
    
  },
  mutations: {
    set_timestamp(state, data) {
      state.timestamp = data
    },
    set_openid(state, data) {
      state.openid = data
    },
    set_language(state, data) {
      state.language = data
    },
    set_shop_id(state, data) {
      state.shopId = data
    }
  },
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js